import { useCompany } from "../Context/CompanyContext";

/**
 * The store's Company document - business name, address, logo, VAT, currency,
 * print + invoice settings and feature switches - as server-authoritative
 * values. Nothing is read from a Profile or localStorage. Kept under this name
 * because ~60 screens already call it; new code can use useCompany() directly.
 */
export function useEffectiveProfile() {
  const { company } = useCompany();
  return { ...(company || {}) };
}

export default useEffectiveProfile;
